import script from "./VTableCredit.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableCredit.vue?vue&type=script&setup=true&lang=js"

import "./VTableCredit.vue?vue&type=style&index=0&id=16b18ab0&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b18ab0"]])

export default __exports__